// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CodBH","control":"styles_control__MVN_D","label":"styles_label__N_vTc","innerLabel":"styles_innerLabel__FfIY6"};